


































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class PricingView extends Vue {
  public items: Common.Pricing[] = new Array(0);
  public params: Common.PricingQuery = new Common.PricingQuery();
  public exportQuery = new Common.ExportQuery('料金プラン', this.params);
  public sortOptions: any = [{ value: 'licenseFlag', text: '料金プラン' }];
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }  
}
